module.exports = __webpack_public_path__ + "img/goldenBlackJack.369d7e96.png";